// shared signin code & config
import { UserManager } from 'oidc-client';

const debounceTime = 5000; // in miliseconds. = 5 seconds

function getConfig(location) {
  // set URL's if domain is test or local
  const hostname = location.hostname;
  const isTest = hostname.includes("test") || hostname.startsWith("dev") || hostname.startsWith("local") || hostname.includes("predeploy");
  const addTest = isTest ? "-test" : "";
  const authUrl = `https://id${addTest}.southaustralia.com/`;
  // const authUrl = `https://localhost:5000/`;
  // const apiHubUrl = `https://apihub${addTest}.southaustralia.com/`;

  // OIDC config
  const config = {
    authority: authUrl, // Account/Login
    client_id: 'tripPlannerM',
    scope: 'openid profile email api1.read api1.write offline_access',
    response_type: 'code',
    redirect_uri: `${location.protocol}//${hostname}${location.port ? `:${location.port}` : ''}/signin-oidc`, //products/barossa/accommodation/cottage-in-the-vines
    post_logout_redirect_uri: `${location.protocol}//${hostname}${location.port ? `:${location.port}` : ''}/signout-oidc`,
    silent_redirect_uri: `${location.protocol}//${hostname}${location.port ? `:${location.port}` : ''}/silent-renew-oidc`,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: false,
    revokeAccessTokenOnSignout: true
  };

  return config;
}


async function getAccessTokenOrSignin(oidcUserManager) {
  // debounce login loops
  const lastLogin = sessionStorage.getItem('lastLogin');
  const now = new Date().getTime();  // returns time in milliseconds

  console.log('lastLogin: ', lastLogin);

  // console.log('lastLogin exists: ', !!lastLogin);
  // console.log('typeof now: ', typeof now);
  const shortNow = parseInt(truncateString(now + '', 10));
  console.log('shortNow: ', shortNow);

  const user = await oidcUserManager.getUser();

  // console.log('user:', user);
  if (!!user && shortNow < (user.expires_at * 1000)) {  // should reduce expired login issues ?
    // console.log('typeof user.expires_at: ', typeof user.expires_at);
    console.log('expires at: ', user.expires_at);
    console.log('not expired?: ', shortNow < (user.expires_at * 1000)); // * 1000 ??
    console.log('remaining time: ', (user.expires_at - shortNow));
    return 'Bearer ' + user.access_token;
  }

  // Redirect technique
  sessionStorage.removeItem('tripModal');


  setRedirectPage();

  const waitTime = calcWaitTime(lastLogin);

  if (!lastLogin || now > waitTime) {  // greater than debounceTime
    sessionStorage.setItem('lastLogin', now);
    await oidcUserManager.signinRedirect();
  } else {
    // grey out AddToTripModal button until timeout has passed
    disableButtonsTemporarily(lastLogin);
  }

  return null;
}


function setRedirectPage() {
  // remember current page for future redirects to return. But NOT /signin-oidc pg.
  const currentPage = `${window.location.href}`;
  // if current page is signin-oidc then don't set it to sessionStorage.
  currentPage.includes('signin-oidc') ? null : sessionStorage.setItem('redirectPage', currentPage);
}


async function getUser(oidcUserManager) {
  // should work even if not supplied a oidcUserManager
  if (!oidcUserManager) {
    console.log('no oidcUserManager. Creating one.');
    const config = getConfig(window.location);
    oidcUserManager = new UserManager(config);
  }

  const user = await oidcUserManager.getUser();

  if (!!user) {
    localStorage.setItem('user_expires_at', user.expires_at);
  }

  // return new Promise((resolve, reject) => {
  //   console.log('getUser debounce.');
  //   let count = 0;

  //   const interval = setInterval(() => {
  //     if(user) {
  //       clearInterval(interval);
  //       resolve(user.profile);
  //     }

  //     count++;
  //     if(count > 10) {
  //       clearInterval(interval);
  //       resolve('');
  //     }
  //   }, 200);
  // });
  return user;
}


function calcWaitTime(lastLogin) {
  // calculates wait remaining from debounceTime for use in a setTimeout.
  if (!!lastLogin) {
    // if last login.
    const now = new Date().getTime();  // returns time in milliseconds

    if ((parseInt(lastLogin) + debounceTime) > now) {
      // if debounceTime is greater than now.
      return (parseInt(lastLogin) + debounceTime) - now;
    }
  }

  return 0; // if no lastLogin or lastLogin too long ago.
}


async function disableButtonsTemporarily(lastLogin) {
  const wait = calcWaitTime(lastLogin);
  $('.tripplan-button').addClass('disabled');
  $('.add-to-trip__button').addClass('disabled');
  setTimeout(function () {
    $('.tripplan-button').removeClass('disabled');
    $('.add-to-trip__button').removeClass('disabled');
  }, wait);
}


async function logoutRemote() {
  try {

    // Send a logout message to trip-southaustralia.com
    let message = { 'code': 'logout_user' }
    let iframe = document.querySelector("#trip-frame");
    iframe.contentWindow.postMessage(message, "*");

    // Logout from our own instance to sign the logout action
    createSignoutUrlOpenInIframe();
    // const config = getConfig(window.location);
    // let oidcUserManager = new UserManager(config);
    // await oidcUserManager.signoutRedirect();
    // // // After the signoutRedirect, you can redirect to a new page.
    // window.location.href = "https://" + window.location.host;
  } catch (error) {
    console.error('Error during signout:', error);
  }
}


function logoutLocal() {
  localStorage.removeItem('LOGGED_IN');
  sessionStorage.removeItem('lastLogin');
  sessionStorage.removeItem('signinPageVisited');
  let config = getConfig(window.location);
  sessionStorage.removeItem(`oidc.user:${config.authority}:${config.client_id}`);
  localStorage.removeItem(`user_token`);
  localStorage.removeItem(`user_expires_at`);
}


async function createSignoutUrlOpenInIframe() {
  // console.log('createSignoutUrl');
  const config = getConfig(window.location);
  let oidcUserManager = new UserManager(config);
  // console.log('oidcUserManager', oidcUserManager);
  let user = await oidcUserManager.getUser();
  console.log('signout this user:', user);
  if (user != null) {
    let id_token_hint = user.id_token;
    let data = '';
    let state = user.session_state;
    const hostname = location.hostname;
    // Despite setting a post_logout_redirect_uri it appears to be ignored by the idserver.
    let post_logout_redirect_uri = `${location.protocol}//${hostname}${location.port ? `:${location.port}` : ''}/signout-oidc`;
    let extraQueryParams = {};
    let request_type = 'Bearer';
    // , extraQueryParams, request_type
    let signoutRequestProperties = { id_token_hint, data, state, post_logout_redirect_uri, extraQueryParams, request_type };
    oidcUserManager.createSignoutRequest(signoutRequestProperties)
      .then(signout_request => {
        console.log('signout_request.url', signout_request.url);
        let iframeFragment = document.createElement('iframe');
        iframeFragment.src = signout_request.url;
        iframeFragment.id = 'signout';
        iframeFragment.style.display = 'none';
        document.querySelector('main').appendChild(iframeFragment);
        // fetch(signout_request.url)  // Fetch get's redirected and then throws an error. Did it still achieve the remote signout?
        // .then(response => {
        //   console.log('TEST 2');
        //   resolve(response)
        // })
        // .catch(err => {
        //   console.error('Error during signout:', err);
        //   reject(err);
        // })
      });
  } else {
    console.log('no user, already signed out.');
  }


  // } catch (error) {
  //     console.error('Error during signout:', error);
  // }
}


function truncateString(str, num) {
  if (typeof str !== 'string' || str.length <= num) {
    return str
  }
  return str.slice(0, num);
}


function checkUserToken() {
  const expires = localStorage.getItem('user_expires_at') || null;
  let token = null;
  let dateNow = Date.now(); // returns a number.
  const now = (dateNow + '').substring(0, 10); // convert to string. Reduce dateNow string to 10 characters.

  console.log('expires_at: ', expires);
  // console.log('typeof dateNow: ', typeof dateNow);
  // console.log('typeof now: ', typeof now);
  console.log('a_time_now: ', now);
  // console.log('expires > now: ', expires > now);

  if (!!expires && expires > now) {
    // const shortNow = parseInt(this.truncateString(now + '', 10));
    token = localStorage.getItem('user_token') || null;
    console.log('TOKEN NOT EXPIRED.');
  }
  return token;
}


async function checkLoginGetStatus() {
  // checks login status and returns an object containing user and token.

  const config = getConfig(window.location);
  const oidcUserManager = new UserManager(config);
  // console.log('config: ', config);
  // console.log('oidcUserManager: ', oidcUserManager);


  // populate current user details in the form from login
  let user = await getUser(oidcUserManager);

  let token = null;

  if (!!user) {
    console.log('logged in.');
    console.log('oidcUserManager: ', oidcUserManager);

    // const token = await this.getAccessToken(oidcUserManager);
    token = await getAccessTokenOrSignin(oidcUserManager);
    // console.log('AA token: ', token);
    localStorage.setItem('user_token', token);
  }

  return { user, token };// no user or no token. Therefore not logged in.

}


// signIn as default,
export { checkUserToken, checkLoginGetStatus, getConfig, getAccessTokenOrSignin, getUser, UserManager, logoutRemote, logoutLocal, disableButtonsTemporarily, calcWaitTime, setRedirectPage };
